import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import SliderRangeListItem from '../../../../../../list-items/SliderListItem/SliderRangeListItem';

const ParticlesSizeListItem = (props) => {
    const { minSize, maxSize, index, updateParticleElement, maxParticleSize } = props;

    const onSizeChange = (value) => {
        previewHistoryBatch.start();
        updateParticleElement(index, { minSize: value[0], maxSize: value[1] });
    };

    return (
        <SliderRangeListItem
            title='Size'
            value={[minSize, maxSize]}
            displayMultiplier={100}
            min={0}
            max={maxParticleSize * 100}
            step={1}
            onValueChange={onSizeChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];
    const { maxParticleSize } = state.create.maxValues;

    return {
        minSize: particleElement.minSize,
        maxSize: particleElement.maxSize,
        maxParticleSize
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesSizeListItem);